// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeStripsSpotClaimBody = {
  poolId: string;
  eventId: string;
  stripNumber: number;
  row: number;
};

export type typeStripsSpotClaimOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { stripNumber: number; row: number; mySpotCount: number };
};

export type typeStripsSpotClaimOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotClaimOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeStripsSpotClaimOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaStripsSpotClaimBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    stripNumber: { type: "integer" },
    row: { type: "integer" },
  },
  required: ["poolId", "eventId", "stripNumber", "row"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createStripsSpotClaim(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaStripsSpotClaimBody);
  }

  return async function postStripsSpotClaim(
    payload: typeStripsSpotClaimBody,
  ): Promise<typeStripsSpotClaimOutput200 | typeStripsSpotClaimOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postStripsSpotClaim" failed before calling the network. #9ff7090a9828`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#9ff7090a9828" },
        },
        data: null,
      } as typeStripsSpotClaimOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/strips/spot-claim`,
      httpMethod: "POST",
      options,
    })) as typeStripsSpotClaimOutput200 | typeStripsSpotClaimOutput400;
  };
}
